import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Button, ButtonGroup, Row, Col, Modal } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Ad from './Ad';

function PornPost() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const encodedUrl = searchParams.get('post');
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showFullscreenModal, setShowFullscreenModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const fetchImages = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const decodedUrl = atob(encodedUrl);
        const response = await fetch(`https://api.qwerty5.workers.dev/?gallery=${encodeURIComponent(decodedUrl)}`);
        if (!response.ok) {
          throw new Error('Failed to fetch images');
        }
        const data = await response.json();
        setImages(data.images);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchImages();
  }, [encodedUrl]);

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setShowFullscreenModal(true);
  };

  if (error) {
    return (
      <Container className="text-center py-5">
        <h3 className="text-danger mb-3">Error: {error}</h3>
        <Button variant="primary" onClick={() => navigate('/porn_view')}>
          Back to Gallery
        </Button>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>Porn Post</title>
        <meta name="description" content="View a collection of porn images" />
        <meta name="keywords" content="porn, adult, images" />
        <meta property="og:title" content="Porn Post" />
        <meta property="og:description" content="View a collection of porn images" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/icon.png" />
        <link rel="icon" type="image/png" href="/icon.png" />
        <link rel="canonical" href={`/porn_post?post=${encodedUrl}`} />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <Container>
        <div className="d-flex flex-column align-items-center mb-4">
          <Ad width={728} height={90} />
          <Ad width={468} height={60} />
          <Ad width={320} height={50} />
        </div>
        
        <div className="text-center my-4">
          <ButtonGroup>
            <Button variant="outline-primary" onClick={() => navigate(-1)}>
              ← Back to Gallery
            </Button>
            <Button variant="outline-primary" onClick={() => navigate('/porn_search')}>
              New Search
            </Button>
            <Button variant="outline-primary" onClick={() => navigate('/')}>
              Home
            </Button>
          </ButtonGroup>
        </div>

        {isLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <Row className="g-3 d-flex justify-content-center">
            {images.map((imageUrl, index) => (
              <Col
                key={index}
                xs={12}
                sm={4}
                md={3}
                lg={2}
                className={`d-flex justify-content-center align-items-center`}
              >
                <img
                  src={imageUrl}
                  alt={`Porn Image ${index + 1}`}
                  className="img-fluid rounded h-100"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'cover',
                    cursor: 'pointer',
                    width: '400px',
                    height: '200px'
                  }}
                  onClick={() => handleImageClick(index)}
                />
              </Col>
            ))}
          </Row>
        )}
      </Container>

      <Modal
        show={showFullscreenModal}
        onHide={() => setShowFullscreenModal(false)}
        dialogClassName="modal-fullscreen"
        contentClassName="bg-transparent border-0"
        centered
      >
        <Modal.Body className="d-flex justify-content-center align-items-center" style={{ padding: 0 }}>
          <img
            src={images[currentImageIndex]}
            alt={`Fullscreen Porn Image ${currentImageIndex + 1}`}
            className="img-fluid mw-100 mh-100"
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
          <Button
            variant="danger"
            className="position-absolute top-0 end-0 m-4"
            onClick={() => setShowFullscreenModal(false)}
          >X
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PornPost;